import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import ErrorBoundary from '@sbt-web/error-boundary';
import type { AdItem, ShopOpeningTime, ShopSocialLinks, ShopGoogleReviews as ShopGoogleReviewsTypes } from '@sbt-web/network/types';
import { Button } from '@sbt-web/ui';
import { shopLinkClick } from '@/client/components/Detail/AdvertiserInfo/AdDetailCompanyPro/tracking';
import { CompanyBadge } from '@/client/components/Detail/UserDetails';
import { escapeUrlWithProtocol } from '@/shared/helpers/EscapeUrl';
import { ShopGoogleReviews } from '../../ShopGoogleReviews';
import { ShopSocial } from './components/Social';
import { OpeningTimeTable } from './OpeningTimeTable';
import Socialization from './Socialization';
import classes from './index.module.scss';
interface AdDetailCompanyProProps {
  name: string;
  item: AdItem;
  adsCount?: number;
  logo?: string;
  address?: string;
  url?: string;
  website?: string;
  social?: ShopSocialLinks;
  shopId?: number;
  openingTime?: ShopOpeningTime;
  showContactButton?: boolean;
  shopGoogleReviews?: ShopGoogleReviewsTypes | null;
}
type ShopWebsiteProps = Pick<AdDetailCompanyProProps, 'website' | 'item'>;
const Placeholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 48 48" width="38%" xmlns="http://www.w3.org/2000/svg"><path d="M34.77 15.5c0 1.657 1.377 3 3.076 3 1.654 0 3.004-1.273 3.074-2.869L38.02 9H9.981L7.08 15.631c.07 1.596 1.42 2.869 3.074 2.869 1.7 0 3.077-1.343 3.077-3 0-.828.689-1.5 1.538-1.5.85 0 1.539.672 1.539 1.5 0 1.657 1.377 3 3.077 3 1.699 0 3.077-1.343 3.077-3 0-.828.688-1.5 1.538-1.5.85 0 1.538.672 1.538 1.5 0 1.657 1.378 3 3.077 3 1.7 0 3.077-1.343 3.077-3 0-.828.69-1.5 1.539-1.5.85 0 1.538.672 1.538 1.5zM12 21.225V39h4.465c-.007-7.412 2.452-11.5 7.535-11.5s7.542 4.088 7.535 11.5H36V21.225a6.175 6.175 0 0 1-2.77-1.756 6.208 6.208 0 0 1-4.615 2.031A6.208 6.208 0 0 1 24 19.469a6.208 6.208 0 0 1-4.615 2.031 6.208 6.208 0 0 1-4.616-2.031A6.175 6.175 0 0 1 12 21.225zm-3 .17c-2.835-.525-4.981-2.945-5-5.857-.005-.213.035-.431.126-.64l3.238-7.4A2.5 2.5 0 0 1 9.654 6h28.692a2.5 2.5 0 0 1 2.29 1.498l3.238 7.4c.091.209.131.427.126.64-.019 2.912-2.165 5.332-5 5.857V39.5a2.5 2.5 0 0 1-2.5 2.5h-6.292l-.065-.001a1.7 1.7 0 0 1-1.633-1.764c.26-6.793-1.306-9.735-4.51-9.735-3.204 0-4.77 2.942-4.51 9.735l.002.065a1.7 1.7 0 0 1-1.7 1.7H11.5A2.5 2.5 0 0 1 9 39.5V21.395z" fill="#AEB9C6" fillRule="evenodd" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ShopWebsite = t0 => {
  const $ = _c(9);
  const {
    website,
    item
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="subheading">Sito web</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== item) {
    t2 = () => {
      shopLinkClick(item);
    };
    $[1] = item;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== website) {
    t3 = <span className="caption book">{website}</span>;
    $[3] = website;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== website) {
    t4 = <div className={classes.website}>{t1}<a href={website} rel="nofollow external noopener noreferrer" className={classes.website_link} aria-label="Vai al sito esterno dello shop" onClick={t2}>{t3}</a></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = website;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const AdDetailCompanyPro = t0 => {
  const $ = _c(44);
  const {
    name,
    item,
    adsCount,
    logo,
    address,
    url,
    website,
    social,
    shopId,
    openingTime,
    showContactButton,
    shopGoogleReviews
  } = t0;
  let t1;
  if ($[0] !== logo || $[1] !== name) {
    t1 = <figure className={classes.shop_image}>{logo ? <img src={logo} alt={name} /> : <Placeholder />}</figure>;
    $[0] = logo;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== item.category.id) {
    t2 = <CompanyBadge categoryId={item.category.id} />;
    $[3] = item.category.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name) {
    t3 = <h6 className="headline-6">{name}</h6>;
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== shopGoogleReviews) {
    t4 = shopGoogleReviews && <ShopGoogleReviews data={shopGoogleReviews} classes={[classes["google-review"]]} />;
    $[7] = shopGoogleReviews;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={classes.company_name}>{t2}{t3}{t4}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t5) {
    t6 = <div className={classes.logo}>{t1}{t5}</div>;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== address) {
    t7 = address && <div className={classes.address}><span className="subheading">Indirizzo</span><p className={classnames("body-text", "book", classes.body_text)}>{address}</p></div>;
    $[16] = address;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== item || $[19] !== website) {
    t8 = website && <ShopWebsite website={escapeUrlWithProtocol(website)} item={item} />;
    $[18] = item;
    $[19] = website;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== item || $[22] !== social) {
    t9 = social && <ShopSocial item={item} social={social} />;
    $[21] = item;
    $[22] = social;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== openingTime) {
    t10 = openingTime && <OpeningTimeTable openingTime={openingTime} />;
    $[24] = openingTime;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t11 = <div className={classes.main_info}>{t7}{t8}{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t6) {
    t12 = <div className={classes.main_data}>{t6}{t11}</div>;
    $[31] = t11;
    $[32] = t6;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== adsCount || $[35] !== shopId || $[36] !== url) {
    t13 = shopId && <Socialization adsCount={adsCount} url={url} />;
    $[34] = adsCount;
    $[35] = shopId;
    $[36] = url;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== showContactButton) {
    t14 = showContactButton && <Button classes={[classes.contactButton]} design="outline" size="small" onClick={_temp}>Contatta</Button>;
    $[38] = showContactButton;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t12 || $[41] !== t13 || $[42] !== t14) {
    t15 = <ErrorBoundary><section className={classes["shop-box-bottom"]}>{t12}{t13}{t14}</section></ErrorBoundary>;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};
function _temp() {
  window.dispatchEvent(new CustomEvent("subito:AdView:BtnAuthorReply"));
}